import { render, staticRenderFns } from "./InformationGenneral.vue?vue&type=template&id=f6618c22&scoped=true"
import script from "./InformationGenneral.vue?vue&type=script&lang=js"
export * from "./InformationGenneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6618c22",
  null
  
)

export default component.exports